//CommonJS to allow resolving in node
export default {
    TIME_DESYNC: "TIME_DESYNC"
};